<template>
  <el-form ref="form" :label-width="labelWidth" label-position="right" size="medium" :model="formData" inline :rules="rules" :inline-message="false">
    <el-form-item v-for="(item, i) in formItems" :key="i" :label="item.label" :prop="item.key">
      <div :style="{ width: contentWidth }">
        <el-date-picker v-if="item.type === 'date'" v-model="formData[item.key]" type="date" size="normal"
          placeholder="请选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        <el-input-number v-else-if="item.type === 'number'" :style="{ width: item.width || '192px' }" v-model="formData[item.key]" size="small" :min="0"
          :placeholder="placeholderWidthFormItem(item)"></el-input-number>
        <el-switch v-else-if="item.type === 'switch'" v-model="formData[item.key]"></el-switch>
        <el-select v-else-if="item.type === 'select'" v-model="formData[item.key]" :placeholder="placeholderWidthFormItem(item)" size="small" clearable>
          <el-option v-for="(option, index) in item.options" :key="index" :label="option.label"
            :value="option.value">
          </el-option>
        </el-select>
        <TagSelector :style="{ width: item.width || '350px' }" v-else-if="item.type === 'tags'" :tag-list="tagList" v-model="formData[item.key]"></TagSelector>
        <el-input v-else :type="item.type" v-model="formData[item.key]" :placeholder="placeholderWidthFormItem(item)" clearable
          size="small"></el-input>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
import TagSelector from '../tagSelector.vue';
import API from '@/api'

export default {
  name: 'ConfigForms',
  components: { TagSelector },
  props: {
    labelWidth: {
      type: String,
      default: '80px'
    },
    contentWidth: {
      type: String,
      default: '200px'
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    /**
     * Array<FormItem>
     * FormItem:
     * - label: string
     * - key: string | number
     * - required: bool
     * - type?: 'select' | 'date' | 'text' | 'textarea' | 'number' | 'tags' 
     * - options?: FormOption[]
     * 
     * 
     * FormOption:
     * - label: string
     * - value: string | number
     */
    formItems: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      formData: {

      },
      tagList: []
    };
  },

  computed: {
    rules() {
      const rs = {}
      this.formItems.forEach(item => {
        rs[item.key] = [
          { required: !!item.required, message: this.placeholderWidthFormItem(item) }
        ]
      });
      return rs
    },
    containTags() {
      return this.formItems.findIndex(v => v.type === 'tags') >= 0
    }
  },

  watch: {
    formItems: {
      handler() {
        this.setFormDataDefault()
        this.getTagList()
      },
      immediate: true
    },
    data: {
      handler(val) {
        console.log(val);
        if (val) {
          Object.assign(this.formData, val)
        }
      },
      immediate: true
    }
  },

  mounted() {
    
  },

  methods: {
    async validate() {
      await this.$refs.form.validate()
      return this.formData
    },
    placeholderWidthFormItem(item) {
      const prefix = {
        select: '请选择',
        date: '请选择',
        text: '请输入',
        number: '请输入',
        tags: '请选择',
        switch: '请选择'
      }
      const cur = prefix[item.type] || '请输入'
      return cur + item.label
    },
    
    setFormDataDefault() {
      this.formItems.forEach(v => {
        this.$set(this.formData, v.key, null)
      })
      if (this.containTags) {
        this.$set(this.formData, 'tags', [])
        // this.formData.tags = []
      }
    },
    getTagList() {
      if (!this.containTags) return
      if (this.tagList && this.tagList.length > 0) return
      const params = {};
      API.queryTagList(params).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>